
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { Grid, Button, Typography, Slider, Radio, Avatar, Chip } from '@mui/material';
import MOBILE_SIDEPANEL_CLASSES from './mobileSidePanelClasses';
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import { updateMobileOfferForm, updateMobileView, clearMobileOfferForm } from '../../../actions/mobileActions'
import { updateLoading, updateSnackbar, clearSelectedShifts, updateEmployeeDashboardData, updateProposalPartialDates } from '../../../actions'
import ShiftCard from '../shiftCard'
import CollapsableCard from '../../../../../common/components/UI/CollapsableCard/CollapsableCard'
import { ProposableShiftsAccordion } from '../../../components/core';
import AvailableTimeOffRequest from '../../Utils/AvailableTimeOffRequest';
import { RequestSource, RequestTypes, ShiftSegmentTypeName, TorCreationType } from '../../../../Enums';
import {
    handleSwapOfferShift, handleOfferShiftToCover, handleSubmitProposal, handlePrivateSwapOfferShiftWithProposal,
} from '../../Utils/handlers'
import { getPartialShiftSliderProps, MomentFormats } from '../../../../utils';
import { parseOverlappingDateTimeOnBreakSegments, handleChangeProposalPartial } from '../../Utils/PartialShiftHelper';
import './summary.scss';
import { DateFnsFormats, formatAs, formatDateRange, getTimeOnly, getAsStartAndEndTimeFormat } from '../../../../../common-client2/src/services/ukgDateTime';



class Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expands: { "proposed": 0, "offered": 0 }
        };
    }

    handleChangePartial = (e, val) => {
        const { formData, updateMobileOfferForm } = this.props
        const shift = formData.shifts[0];
        const startDate = moment.utc(shift.startDateTime);

        const newStartDate = moment.utc(startDate).add(val[0], 'm')
        const newEndDate = moment.utc(startDate).add(val[1], 'm')
        updateMobileOfferForm({
            ...formData,
            partialDates: {
                startDate: newStartDate,
                endDate: newEndDate,
            }
        })
    }

    handleChangeProposalPartialInSwapWithProposal = (e, val, shifts, requestType) => handleChangeProposalPartial(this.props.updateProposalPartialDates, e, val, shifts, requestType);

    handleSummaryChangeProposalPartial = (e, val) => {
        const { mobileProposalShiftsSelected } = this.props
        this.handleChangeProposalPartialInSwapWithProposal(e, val, mobileProposalShiftsSelected, RequestTypes.shiftSwap);
    };

    handleSubmit = async () => {
        const { formData, proposalPartialDates, mobileView, updateMobileView, mobileProposalShiftsSelected, clearMobileOfferForm, selectedProposableShiftsByOfferor } = this.props
        const { managerSetting, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected } = formData;
        const { employee, shifts } = selectedProposableShiftsByOfferor;
        const isAllowProposalWithOffer = managerSetting.isAllowProposalWithOffer;

        switch (managerSetting.type) {
            case RequestTypes.toCover:
                await handleOfferShiftToCover.bind(this)(managerSetting, formData.shifts, formData.partialDates, formData.privateEmployeeSelected, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected)
                break;
            case RequestTypes.shiftSwap:
                if (formData.source === RequestSource.Offerer) {
                    if (formData.isPrivate && isAllowProposalWithOffer) {
                        if (!employee.employeeId || !shifts.length) {
                            this.handleSnackbar('error', 'At least one person and one shift needs to be selected', true)
                            return
                        }
                        await handlePrivateSwapOfferShiftWithProposal.bind(this)(
                            managerSetting,
                            employee.employeeId,
                            formData.shifts,
                            shifts,
                            formData.partialDates,
                            proposalPartialDates,
                        );
                    }
                    else {
                        if (formData.isPrivate && formData.privateEmployeeSelected.length === 0) {
                            this.handleSnackbar('error', 'At least one person needs to be selected', true);
                            return;
                        }
                        await handleSwapOfferShift.bind(this)(formData.managerSetting, formData.privateEmployeeSelected, formData.preferredDates, formData.shifts, formData.partialDates)
                    }
                }
                else {
                    await handleSubmitProposal.bind(this)(formData, mobileProposalShiftsSelected, proposalPartialDates)
                }
                break
            default:
                break
        }
        updateMobileView(mobileView.previous)
        clearMobileOfferForm()
    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    render() {
        const { classes, formData, t } = this.props
        const shiftInfo = () => {
            const shift = formData.shifts[0]
            let orgJob = shift.segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT).shortOrgJobPath
            return (
                <Fragment>
                    <Typography className={classes.subHeader}>Info</Typography>
                    <div className={classes.shiftCard}>
                        <Typography variant={'subtitle1'}>
                            {`${shift.label ?? ""} ${getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}`}
                        </Typography>
                        {shift.assignmentName && (
                            <Typography variant={'subtitle2'}>
                                {t('billboard.assignment', { name: shift.assignmentName })}
                            </Typography>
                        )}
                        <Typography style={{ fontWeight: 700 }}>
                            {formatAs(shift.startDateTime, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
                        </Typography>
                        <Typography variant={'subtitle2'} style={{ fontWeight: 300, color: '#C1C1C1' }}>
                            {orgJob}
                        </Typography>
                    </div>
                </Fragment>
            )
        }

        const partialShift = () => {
            const shift = formData.shifts[0];
            const { startDate: parsedPartialStartDate, endDate: parsedPartialEndDate } = parseOverlappingDateTimeOnBreakSegments(formData.partialDates.startDate, formData.partialDates.endDate, shift.segments)
            const selectedPartial = formatDateRange(parsedPartialStartDate.format(MomentFormats.ISO), parsedPartialEndDate.format(MomentFormats.ISO), getTimeOnly);
            const { defaultValue, marks, max, step } = getPartialShiftSliderProps(shift, parsedPartialStartDate, parsedPartialEndDate);
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <Typography className={classes.subHeader}>{this.props.t('billboard.partialShiftOption')}</Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: '0 20px' }}>
                        <Slider //Cannot use SliderPartialRequest, as summary requires a defaultValue
                            defaultValue={defaultValue}
                            onChangeCommitted={(e, val) => this.handleChangePartial(e, val)}
                            marks={marks}
                            max={max}
                            valueLabelDisplay="off"
                            step={step}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ backgroundColor: '#1a518a', color: '#FFF', textAlign: 'center', padding: '10px 0' }}>
                        {selectedPartial}
                    </Grid>
                </Grid>
            )
        }

        const proposalPartialShift = () => {
            const { mobileProposalShiftsSelected, proposalPartialDates, } = this.props;
            const shift = mobileProposalShiftsSelected[0];
            const { startDate: parsedPartialStartDate, endDate: parsedPartialEndDate } = parseOverlappingDateTimeOnBreakSegments(proposalPartialDates.startDate, proposalPartialDates.endDate, shift.segments)
            const selectedPartial = formatDateRange(parsedPartialStartDate.format(MomentFormats.ISO), parsedPartialEndDate.format(MomentFormats.ISO), getTimeOnly);
            const { defaultValue, marks, max, step } = getPartialShiftSliderProps(shift, parsedPartialStartDate, parsedPartialEndDate);
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <Typography className={classes.subHeader}>Proposal Partial Shift (Optional)</Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: '0 20px' }}>
                        <Slider //Cannot use SliderPartialRequest, as summary requires a defaultValue
                            defaultValue={defaultValue}
                            onChangeCommitted={(e, val) => this.handleSummaryChangeProposalPartial(e, val)}
                            marks={marks}
                            max={max}
                            valueLabelDisplay="off"
                            step={step}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ backgroundColor: '#1a518a', color: '#FFF', textAlign: 'center', padding: '10px 0' }}>
                        {selectedPartial}
                    </Grid>
                </Grid>
            )
        }

        const availableTimeOff = () => {
            const { sidePanelData } = this.props;
            return (
                <div className="summary-timeOffSection">
                    <AvailableTimeOffRequest
                        timeOffRequest={sidePanelData.timeOffRequest}
                        error={sidePanelData.timeOffRequestError}
                    />
                </div>
            );
        }

        const timeOffRequestCreation = () => {
            const { formData, timeOffRequestSubtypes } = this.props;
            const { timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected } = formData;
            const subtype = timeOffRequestSubtypes.find(x => x.id === timeOffRequestSubtypeIdSelected);
            const reason = subtype.reasons.find(x => x.id === timeOffRequestReasonIdSelected);
            return (
                <div>
                    <Typography className={classes.subHeader}>Created time-off request subtype</Typography>
                    <Button fullWidth className={classes.formButton}>
                        <Radio
                            color="primary"
                            checked={true}
                            value="false"
                        />
                        {subtype.name}
                    </Button>
                    {!!reason && (
                        <>
                            <Typography className={classes.subHeader}>Created time-off request reason</Typography>
                            <Button fullWidth className={classes.formButton}>
                                <Radio
                                    color="primary"
                                    checked={true}
                                    value="false"
                                />
                                {reason.label}
                            </Button>
                        </>)}
                </div>
            );
        }

        const sendTo = () => {
            return (
                <Fragment>
                    <Typography className={classes.subHeader}>Send to</Typography>
                    <Button fullWidth className={classes.formButton}>
                        <Radio
                            color="primary"
                            checked={true}
                            value="false"
                        />
                        {formData.isPrivate ? 'To employee(s)' : 'To billboard'}
                    </Button>
                </Fragment>
            )
        }
        const preferredDates = () => {
            if (!formData.managerSetting || formData.managerSetting.type !== RequestTypes.shiftSwap || !formData.managerSetting.isShiftSwapEmployeePreferencesEnabled || formData.preferredDates.length <= 0) {
                return
            }

            return (
                <Fragment>
                    <Typography className={classes.subHeader}>Preferred swap dates</Typography>
                    {formData.preferredDates.map(date => {
                        return <Typography className={classes.recipientNameStyle}>{formatAs(date, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}</Typography>
                    })}
                </Fragment>
            )
        }

        const multiShift = (shifts, title, expandKey, isPartial) => {
            let { expands } = this.state;
            return (
                <CollapsableCard
                    title={title}
                    avatar={<Avatar className={classes.avatar} />}
                    expanded={expands[expandKey]}
                    handleCollapse={() => {
                        expands[expandKey] = !expands[expandKey];
                        this.setState({ expands: expands })
                    }} >
                    {
                        shifts.map(shift => {
                            let segment = shift.segments.find(x => x.segmentTypeRef.qualifier !== ShiftSegmentTypeName.BREAK_SEGMENT);
                            let primaryJob = segment ? segment.shortOrgJobPath : null;
                            return (
                                <ShiftCard
                                    color={0}
                                    shiftType={null}
                                    startDate={shift.startDateTime}
                                    endDate={shift.endDateTime}
                                    orgJob={primaryJob}
                                    isPartial={isPartial}
                                    shiftTemplateLabel={shift.label}
                                    assignmentName={shift.assignmentName}
                                />
                            )
                        })
                    }
                </CollapsableCard>
            )
        }

        const renderView = () => {
            const { formData, mobileProposalShiftsSelected, selectedProposableShiftsByOfferor } = this.props;
            const { isEmployeeCanMakePartials } = selectedProposableShiftsByOfferor;
            if (formData.type === RequestTypes.shiftSwap) {
                const shiftsInOffer = formData.raw.isPartial ? [formData.raw.partialShift] : formData.shifts;
                return (
                    <Fragment>
                        {renderOfferOwnership(formData.raw.offerorEmployeeName)}
                        <div style={{ marginBottom: 10 }}>
                            {multiShift(shiftsInOffer, 'Offered shift(s)', "offered", formData.raw.isPartial)}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            {formData.managerSetting.isPartialShiftEnabled
                                ? proposalPartialShift()
                                : multiShift(mobileProposalShiftsSelected, 'Proposed shift(s)', "proposed", false)}
                        </div>
                    </Fragment>
                )
            }
            else {
                return (
                    <Fragment>
                        <div style={{ marginBottom: 10 }}>
                            {shiftInfo()}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            {formData.managerSetting.isPartialShiftEnabled ? partialShift() : null}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            {formData.raw.isProposedByOfferer && isEmployeeCanMakePartials ? proposalPartialShift() : null}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            {sendTo()}
                            {preferredDates()}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            {formData.isPrivate ? renderPrivateOfferEmployeeList() : null}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            {formData.managerSetting.timeOffRequestCreationType == TorCreationType.Optional || formData.managerSetting.timeOffRequestCreationType == TorCreationType.Required ? timeOffRequestCreation() : null}
                        </div>
                    </Fragment>
                )
            }
        }

        const renderOfferOwnership = (employeeName) => {
            const { classes } = this.props
            return (
                <Grid container className={classes.ownerSection}>
                    <Grid item xs={2}><Avatar alt={`${employeeName}`} /></Grid>
                    <Grid item xs={10} className={classes.shiftInfoHeaderEmployeeNameWrapper}>
                        <Typography component='div' className={classes.shiftInfoHeaderEmployeeName} >{employeeName}</Typography>
                    </Grid>
                </Grid>
            )
        }

        const renderPrivateOfferEmployeeList = () => {
            const { formData, updateMobileOfferForm, selectedProposableShiftsByOfferor, proposalPartialDates, proposableShiftsPerEmployee } = this.props;
            if (formData.managerSetting.isAllowProposalWithOffer) {
                const { employee, shifts } = selectedProposableShiftsByOfferor;
                return (
                    <ProposableShiftsAccordion
                        employee={employee}
                        selectedEmployeeId={employee.employeeId}
                        onShiftChecked={() => { }}
                        getEmployeeProposableShifts={() => proposableShiftsPerEmployee[employee.employeeId]}
                        selectedShifts={shifts}
                        sliderPartialRequestData={{ offeredShiftsCount: formData.shifts.length }}
                        handleChangeProposalPartial={this.handleChangeProposalPartialInSwapWithProposal}
                        selectedPartialLabel={proposalPartialDates.partialShiftLabel}
                        selectedPartialStartDate={proposalPartialDates.startDate}
                        selectedPartialEndDate={proposalPartialDates.endDate}
                        isReadOnly
                    />
                );
            }
            const privateEmployeesChips = formData.privateEmployeeSelected.map((x, i) => {
                return (
                    <Chip
                        label={x.label}
                        onDelete={() => {
                            var updatedList = formData.privateEmployeeSelected.filter(ee => ee != x);
                            updateMobileOfferForm({ privateEmployeeSelected: updatedList });
                        }}
                        variant="outlined"
                    />
            )});
            return privateEmployeesChips;
        }

        return (
            <div className={classes.viewContainer}>
                <Typography variant={'h5'} className={classes.viewHeader}>Confirmation </Typography>
                {renderView()}
                <Grid container className={classes.bottomBar}>
                    <Grid item xs={12} style={{ padding: '5px' }}>
                        <Button fullWidth className={classes.primaryButton} onClick={() => this.handleSubmit()}>
                            Confirm
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        classes: MOBILE_SIDEPANEL_CLASSES,
        storeData: state.data,
        formData: state.mobileOfferShiftForm,
        mobileView: state.mobileView,
        person: state.person,
        options: state.httpOptions,
        mobileProposalShiftsSelected: state.mobileProposalShiftsSelected,
        statusDictionary: state.statusDictionary,
        dateRanges: state.dateRanges,
        proposableShiftsPerEmployee: state.proposableShiftsPerEmployee,
        selectedProposableShiftsByOfferor: state.selectedProposableShiftsByOfferor,
        sidePanelData: state.sidePanelData,
        timeOffRequestSubtypes: state.timeOffRequestSubtypes,
        proposalPartialDates: state.proposalPartialDates,
        managerSettings: state.managerSettings,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateLoading: payload => dispatch(updateLoading(payload)),
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
        updateMobileView: payload => dispatch(updateMobileView(payload)),
        updateSnackbar: payload => dispatch(updateSnackbar(payload)),
        clearSelectedShifts: () => dispatch(clearSelectedShifts()),
        clearMobileOfferForm: () => dispatch(clearMobileOfferForm()),
        updateEmployeeDashboardData: (payload) => dispatch(updateEmployeeDashboardData(payload)),
        updateProposalPartialDates: (payload) => dispatch(updateProposalPartialDates(payload))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(Summary));